// AUTO-GENERATED from Choice_Wealth_Final_Keyword_List_Meta_Titles_Descriptions_Ready_For_Implementation_05-08-2026.xlsx
// (sheet "Keyword New"). Single source of truth for per-page SEO metadata.
// Keyed by App.tsx RouteMatch["type"]. Do not hand-edit values — update the Excel
// and regenerate. See App.tsx useEffect where these override the per-route defaults.
// Canonicals are stored exactly as the sheet provides (production host); App.tsx
// rebases the host to whatever origin serves the page (live / uat / dev / local).

// Every field is optional: a field is present only when the sheet populated it.
// A missing field means "leave the page's existing value unchanged" (never invent).
export type SeoMetadata = {
  metaTitle?: string;
  metaDescription?: string;
  ogTitle?: string;
  ogDescription?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  canonical?: string;
};

export const SEO_METADATA: Record<string, SeoMetadata> = {
  modernHome: {
    metaTitle: "Wealth Management Firm in India | Choice Wealth",
    metaDescription: "Choice Wealth helps serious investors review wealth across risk, liquidity, product exposure and long-term structure through RM-led conversations.",
    ogTitle: "Wealth Management Firm in India | Choice Wealth",
    ogDescription: "Choice Wealth helps serious investors review wealth across risk, liquidity, product exposure and long-term structure through RM-led conversations.",
    twitterTitle: "Wealth Management Firm in India | Choice Wealth",
    twitterDescription: "Choice Wealth helps serious investors review wealth across risk, liquidity, product exposure and long-term structure through RM-led conversations.",
    canonical: "https://choicewealth.in",
  },
  modernHomeTwo: {
    metaTitle: "Wealth Management Firm in India | Choice Wealth",
    metaDescription: "Choice Wealth helps serious investors review wealth across risk, liquidity, product exposure and long-term structure through RM-led conversations.",
    ogTitle: "Wealth Management Firm in India | Choice Wealth",
    ogDescription: "Choice Wealth helps serious investors review wealth across risk, liquidity, product exposure and long-term structure through RM-led conversations.",
    twitterTitle: "Wealth Management Firm in India | Choice Wealth",
    twitterDescription: "Choice Wealth helps serious investors review wealth across risk, liquidity, product exposure and long-term structure through RM-led conversations.",
    canonical: "https://choicewealth.in",
  },
  modernHomeThree: {
    metaTitle: "Wealth Management Firm in India | Choice Wealth",
    metaDescription: "Choice Wealth helps serious investors review wealth across risk, liquidity, product exposure and long-term structure through RM-led conversations.",
    ogTitle: "Wealth Management Firm in India | Choice Wealth",
    ogDescription: "Choice Wealth helps serious investors review wealth across risk, liquidity, product exposure and long-term structure through RM-led conversations.",
    twitterTitle: "Wealth Management Firm in India | Choice Wealth",
    twitterDescription: "Choice Wealth helps serious investors review wealth across risk, liquidity, product exposure and long-term structure through RM-led conversations.",
    canonical: "https://choicewealth.in",
  },
  portfolioManagementServicesTwo: {
    metaTitle: "Portfolio Management Services in India | Choice Wealth",
    metaDescription: "Review Portfolio Management Services through portfolio objective, risk comfort, eligibility, strategy context and disciplined review.",
    ogTitle: "Portfolio Management Services in India | Choice Wealth",
    ogDescription: "Review Portfolio Management Services through portfolio objective, risk comfort, eligibility, strategy context and disciplined review.",
    twitterTitle: "Portfolio Management Services in India | Choice Wealth",
    twitterDescription: "Review Portfolio Management Services through portfolio objective, risk comfort, eligibility, strategy context and disciplined review.",
    canonical: "https://choicewealth.in/pms-portfolio-management-services",
  },
  pms: {
    metaTitle: "Portfolio Management Services in India | Choice Wealth",
    metaDescription: "Review Portfolio Management Services through portfolio objective, risk comfort, eligibility, strategy context and disciplined review.",
    ogTitle: "Portfolio Management Services in India | Choice Wealth",
    ogDescription: "Review Portfolio Management Services through portfolio objective, risk comfort, eligibility, strategy context and disciplined review.",
    twitterTitle: "Portfolio Management Services in India | Choice Wealth",
    twitterDescription: "Review Portfolio Management Services through portfolio objective, risk comfort, eligibility, strategy context and disciplined review.",
    canonical: "https://choicewealth.in/pms-portfolio-management-services",
  },
  aifProduct: {
    metaTitle: "Alternative Investment Funds | Choice Wealth",
    metaDescription: "Explore AIFs as alternative allocation routes for eligible investors after reviewing portfolio role, liquidity, risk and product terms.",
    ogTitle: "Alternative Investment Funds | Choice Wealth",
    ogDescription: "Explore AIFs as alternative allocation routes for eligible investors after reviewing portfolio role, liquidity, risk and product terms.",
    twitterTitle: "Alternative Investment Funds | Choice Wealth",
    twitterDescription: "Explore AIFs as alternative allocation routes for eligible investors after reviewing portfolio role, liquidity, risk and product terms.",
    canonical: "https://choicewealth.in/aif-alternative-investment-funds",
  },
  aif: {
    metaTitle: "Alternative Investment Funds | Choice Wealth",
    metaDescription: "Explore AIFs as alternative allocation routes for eligible investors after reviewing portfolio role, liquidity, risk and product terms.",
    ogTitle: "Alternative Investment Funds | Choice Wealth",
    ogDescription: "Explore AIFs as alternative allocation routes for eligible investors after reviewing portfolio role, liquidity, risk and product terms.",
    twitterTitle: "Alternative Investment Funds | Choice Wealth",
    twitterDescription: "Explore AIFs as alternative allocation routes for eligible investors after reviewing portfolio role, liquidity, risk and product terms.",
    canonical: "https://choicewealth.in/aif-alternative-investment-funds",
  },
  mutualFundProduct: {
    metaTitle: "Mutual Fund Investment Review | Choice Wealth",
    metaDescription: "Review mutual fund options by portfolio role, goals, liquidity, risk and allocation fit before adding another fund.",
    ogTitle: "Mutual Fund Investment Review | Choice Wealth",
    ogDescription: "Review mutual fund options by portfolio role, goals, liquidity, risk and allocation fit before adding another fund.",
    twitterTitle: "Mutual Fund Investment Review | Choice Wealth",
    twitterDescription: "Review mutual fund options by portfolio role, goals, liquidity, risk and allocation fit before adding another fund.",
    canonical: "https://choicewealth.in/mutual-funds-advisory",
  },
  mutualFunds: {
    metaTitle: "Mutual Fund Investment Review | Choice Wealth",
    metaDescription: "Review mutual fund options by portfolio role, goals, liquidity, risk and allocation fit before adding another fund.",
    ogTitle: "Mutual Fund Investment Review | Choice Wealth",
    ogDescription: "Review mutual fund options by portfolio role, goals, liquidity, risk and allocation fit before adding another fund.",
    twitterTitle: "Mutual Fund Investment Review | Choice Wealth",
    twitterDescription: "Review mutual fund options by portfolio role, goals, liquidity, risk and allocation fit before adding another fund.",
    canonical: "https://choicewealth.in/mutual-funds-advisory",
  },
  fixedIncomeProduct: {
    metaTitle: "Fixed Income Investment Options | Choice Wealth",
    metaDescription: "Review fixed income options by issuer, tenure, payout, liquidity and risk before adding an income-oriented layer to your portfolio.",
    ogTitle: "Fixed Income Investment Options | Choice Wealth",
    ogDescription: "Review fixed income options by issuer, tenure, payout, liquidity and risk before adding an income-oriented layer to your portfolio.",
    twitterTitle: "Fixed Income Investment Options | Choice Wealth",
    twitterDescription: "Review fixed income options by issuer, tenure, payout, liquidity and risk before adding an income-oriented layer to your portfolio.",
    canonical: "https://choicewealth.in/fixed-income-investments",
  },
  fixedIncome: {
    metaTitle: "Fixed Income Investment Options | Choice Wealth",
    metaDescription: "Review fixed income options by issuer, tenure, payout, liquidity and risk before adding an income-oriented layer to your portfolio.",
    ogTitle: "Fixed Income Investment Options | Choice Wealth",
    ogDescription: "Review fixed income options by issuer, tenure, payout, liquidity and risk before adding an income-oriented layer to your portfolio.",
    twitterTitle: "Fixed Income Investment Options | Choice Wealth",
    twitterDescription: "Review fixed income options by issuer, tenure, payout, liquidity and risk before adding an income-oriented layer to your portfolio.",
    canonical: "https://choicewealth.in/fixed-income-investments",
  },
  fixedIncomeTwo: {
    metaTitle: "Fixed Income Investment Options | Choice Wealth",
    metaDescription: "Review fixed income options by issuer, tenure, payout, liquidity and risk before adding an income-oriented layer to your portfolio.",
    ogTitle: "Fixed Income Investment Options | Choice Wealth",
    ogDescription: "Review fixed income options by issuer, tenure, payout, liquidity and risk before adding an income-oriented layer to your portfolio.",
    twitterTitle: "Fixed Income Investment Options | Choice Wealth",
    twitterDescription: "Review fixed income options by issuer, tenure, payout, liquidity and risk before adding an income-oriented layer to your portfolio.",
    canonical: "https://choicewealth.in/fixed-income-investments",
  },
  bondsProduct: {
    metaTitle: "Bond Investment Options in India | Choice Wealth",
    metaDescription: "Review bond investment options across issuer profile, coupon, maturity, liquidity and credit risk before product access.",
    ogTitle: "Bond Investment Options in India | Choice Wealth",
    ogDescription: "Review bond investment options across issuer profile, coupon, maturity, liquidity and credit risk before product access.",
    twitterTitle: "Bond Investment Options in India | Choice Wealth",
    twitterDescription: "Review bond investment options across issuer profile, coupon, maturity, liquidity and credit risk before product access.",
    canonical: "https://choicewealth.in/bonds-investment",
  },
  bonds: {
    metaTitle: "Bond Investment Options in India | Choice Wealth",
    metaDescription: "Review bond investment options across issuer profile, coupon, maturity, liquidity and credit risk before product access.",
    ogTitle: "Bond Investment Options in India | Choice Wealth",
    ogDescription: "Review bond investment options across issuer profile, coupon, maturity, liquidity and credit risk before product access.",
    twitterTitle: "Bond Investment Options in India | Choice Wealth",
    twitterDescription: "Review bond investment options across issuer profile, coupon, maturity, liquidity and credit risk before product access.",
    canonical: "https://choicewealth.in/bonds-investment",
  },
  ncdProduct: {
    metaTitle: "NCD Investment Options in India | Choice Wealth",
    metaDescription: "Understand NCDs as listed debt instruments with coupon and maturity terms, subject to credit, market and liquidity risks.",
    ogTitle: "NCD Investment Options in India | Choice Wealth",
    ogDescription: "Understand NCDs as listed debt instruments with coupon and maturity terms, subject to credit, market and liquidity risks.",
    twitterTitle: "NCD Investment Options in India | Choice Wealth",
    twitterDescription: "Understand NCDs as listed debt instruments with coupon and maturity terms, subject to credit, market and liquidity risks.",
    canonical: "https://choicewealth.in/ncd-non-convertible-debentures",
  },
  corporateFdTwo: {
    metaTitle: "Corporate Fixed Deposit Options | Choice Wealth",
    metaDescription: "Review corporate FD options by issuer profile, tenure, payout need, product terms and applicable issuer risk before investing.",
    ogTitle: "Corporate Fixed Deposit Options | Choice Wealth",
    ogDescription: "Review corporate FD options by issuer profile, tenure, payout need, product terms and applicable issuer risk before investing.",
    twitterTitle: "Corporate Fixed Deposit Options | Choice Wealth",
    twitterDescription: "Review corporate FD options by issuer profile, tenure, payout need, product terms and applicable issuer risk before investing.",
    canonical: "https://choicewealth.in/corporate-fixed-deposits",
  },
  corporateFd: {
    metaTitle: "Corporate Fixed Deposit Options | Choice Wealth",
    metaDescription: "Review corporate FD options by issuer profile, tenure, payout need, product terms and applicable issuer risk before investing.",
    ogTitle: "Corporate Fixed Deposit Options | Choice Wealth",
    ogDescription: "Review corporate FD options by issuer profile, tenure, payout need, product terms and applicable issuer risk before investing.",
    twitterTitle: "Corporate Fixed Deposit Options | Choice Wealth",
    twitterDescription: "Review corporate FD options by issuer profile, tenure, payout need, product terms and applicable issuer risk before investing.",
    canonical: "https://choicewealth.in/corporate-fixed-deposits",
  },
  mldProduct: {
    metaTitle: "Market Linked Debentures | Choice Wealth",
    metaDescription: "Understand MLDs as structured products where payoff depends on defined market-linked conditions, product terms and risks.",
    ogTitle: "Market Linked Debentures | Choice Wealth",
    ogDescription: "Understand MLDs as structured products where payoff depends on defined market-linked conditions, product terms and risks.",
    twitterTitle: "Market Linked Debentures | Choice Wealth",
    twitterDescription: "Understand MLDs as structured products where payoff depends on defined market-linked conditions, product terms and risks.",
    canonical: "https://choicewealth.in/mld-market-linked-debentures",
  },
  mld: {
    metaTitle: "Market Linked Debentures | Choice Wealth",
    metaDescription: "Understand MLDs as structured products where payoff depends on defined market-linked conditions, product terms and risks.",
    ogTitle: "Market Linked Debentures | Choice Wealth",
    ogDescription: "Understand MLDs as structured products where payoff depends on defined market-linked conditions, product terms and risks.",
    twitterTitle: "Market Linked Debentures | Choice Wealth",
    twitterDescription: "Understand MLDs as structured products where payoff depends on defined market-linked conditions, product terms and risks.",
    canonical: "https://choicewealth.in/mld-market-linked-debentures",
  },
  sifProduct: {
    metaTitle: "Specialised Investment Funds | Choice Wealth",
    metaDescription: "Review SIF eligibility, product rules, strategy role and portfolio fit before considering specialised investment fund access.",
    ogTitle: "Specialised Investment Funds | Choice Wealth",
    ogDescription: "Review SIF eligibility, product rules, strategy role and portfolio fit before considering specialised investment fund access.",
    twitterTitle: "Specialised Investment Funds | Choice Wealth",
    twitterDescription: "Review SIF eligibility, product rules, strategy role and portfolio fit before considering specialised investment fund access.",
    canonical: "https://choicewealth.in/sif-specialised-investment-funds",
  },
  npsProduct: {
    metaTitle: "National Pension System Investment | Choice Wealth",
    metaDescription: "Review NPS as one retirement contribution route within a broader income, liquidity and long-term wealth structure.",
    ogTitle: "National Pension System Investment | Choice Wealth",
    ogDescription: "Review NPS as one retirement contribution route within a broader income, liquidity and long-term wealth structure.",
    twitterTitle: "National Pension System Investment | Choice Wealth",
    twitterDescription: "Review NPS as one retirement contribution route within a broader income, liquidity and long-term wealth structure.",
    canonical: "https://choicewealth.in/nps-national-pension-system",
  },
  nps: {
    metaTitle: "National Pension System Investment | Choice Wealth",
    metaDescription: "Review NPS as one retirement contribution route within a broader income, liquidity and long-term wealth structure.",
    ogTitle: "National Pension System Investment | Choice Wealth",
    ogDescription: "Review NPS as one retirement contribution route within a broader income, liquidity and long-term wealth structure.",
    twitterTitle: "National Pension System Investment | Choice Wealth",
    twitterDescription: "Review NPS as one retirement contribution route within a broader income, liquidity and long-term wealth structure.",
    canonical: "https://choicewealth.in/nps-national-pension-system",
  },
  whoWeServeHniPrivateWealth: {
    metaTitle: "HNI & Private Wealth Management | Choice Wealth",
    metaDescription: "Review HNI wealth management through an RM-led conversation focused on portfolio structure, risk, liquidity and product access.",
    ogTitle: "HNI & Private Wealth Management | Choice Wealth",
    ogDescription: "Review HNI wealth management through an RM-led conversation focused on portfolio structure, risk, liquidity and product access.",
    twitterTitle: "HNI & Private Wealth Management | Choice Wealth",
    twitterDescription: "Review HNI wealth management through an RM-led conversation focused on portfolio structure, risk, liquidity and product access.",
    canonical: "https://choicewealth.in/hni-private-wealth-management",
  },
  hniPrivateWealth: {
    metaTitle: "HNI & Private Wealth Management | Choice Wealth",
    metaDescription: "Review HNI wealth management through an RM-led conversation focused on portfolio structure, risk, liquidity and product access.",
    ogTitle: "HNI & Private Wealth Management | Choice Wealth",
    ogDescription: "Review HNI wealth management through an RM-led conversation focused on portfolio structure, risk, liquidity and product access.",
    twitterTitle: "HNI & Private Wealth Management | Choice Wealth",
    twitterDescription: "Review HNI wealth management through an RM-led conversation focused on portfolio structure, risk, liquidity and product access.",
    canonical: "https://choicewealth.in/hni-private-wealth-management",
  },
  whoWeServeNriGlobalIndianWealth: {
    metaTitle: "NRI Wealth Management in India | Choice Wealth",
    metaDescription: "Review India-linked wealth for NRIs across documentation, residency, repatriation context, eligibility and product risk.",
    ogTitle: "NRI Wealth Management in India | Choice Wealth",
    ogDescription: "Review India-linked wealth for NRIs across documentation, residency, repatriation context, eligibility and product risk.",
    twitterTitle: "NRI Wealth Management in India | Choice Wealth",
    twitterDescription: "Review India-linked wealth for NRIs across documentation, residency, repatriation context, eligibility and product risk.",
    canonical: "https://choicewealth.in/nri-global-indian-wealth-management",
  },
  nriGlobalIndianWealth: {
    metaTitle: "NRI Wealth Management in India | Choice Wealth",
    metaDescription: "Review India-linked wealth for NRIs across documentation, residency, repatriation context, eligibility and product risk.",
    ogTitle: "NRI Wealth Management in India | Choice Wealth",
    ogDescription: "Review India-linked wealth for NRIs across documentation, residency, repatriation context, eligibility and product risk.",
    twitterTitle: "NRI Wealth Management in India | Choice Wealth",
    twitterDescription: "Review India-linked wealth for NRIs across documentation, residency, repatriation context, eligibility and product risk.",
    canonical: "https://choicewealth.in/nri-global-indian-wealth-management",
  },
  whoWeServeCorporateTreasury: {
    metaTitle: "Corporate Treasury Solutions | Choice Wealth",
    metaDescription: "Review corporate surplus deployment across liquidity, tenure, issuer risk, governance and reporting context before product access.",
    ogTitle: "Corporate Treasury Solutions | Choice Wealth",
    ogDescription: "Review corporate surplus deployment across liquidity, tenure, issuer risk, governance and reporting context before product access.",
    twitterTitle: "Corporate Treasury Solutions | Choice Wealth",
    twitterDescription: "Review corporate surplus deployment across liquidity, tenure, issuer risk, governance and reporting context before product access.",
    canonical: "https://choicewealth.in/corporate-treasury-solutions",
  },
  corporateTreasury: {
    metaTitle: "Corporate Treasury Solutions | Choice Wealth",
    metaDescription: "Review corporate surplus deployment across liquidity, tenure, issuer risk, governance and reporting context before product access.",
    ogTitle: "Corporate Treasury Solutions | Choice Wealth",
    ogDescription: "Review corporate surplus deployment across liquidity, tenure, issuer risk, governance and reporting context before product access.",
    twitterTitle: "Corporate Treasury Solutions | Choice Wealth",
    twitterDescription: "Review corporate surplus deployment across liquidity, tenure, issuer risk, governance and reporting context before product access.",
    canonical: "https://choicewealth.in/corporate-treasury-solutions",
  },
  whoWeServeFamilyOffice: {
    metaTitle: "Family Office Services in India | Choice Wealth",
    metaDescription: "Review family wealth across governance, continuity, liquidity, reporting and product access with a structured RM-led conversation.",
    ogTitle: "Family Office Services in India | Choice Wealth",
    ogDescription: "Review family wealth across governance, continuity, liquidity, reporting and product access with a structured RM-led conversation.",
    twitterTitle: "Family Office Services in India | Choice Wealth",
    twitterDescription: "Review family wealth across governance, continuity, liquidity, reporting and product access with a structured RM-led conversation.",
    canonical: "https://choicewealth.in/family-office-business-families",
  },
  familyOfficeBusinessFamilies: {
    metaTitle: "Family Office Services in India | Choice Wealth",
    metaDescription: "Review family wealth across governance, continuity, liquidity, reporting and product access with a structured RM-led conversation.",
    ogTitle: "Family Office Services in India | Choice Wealth",
    ogDescription: "Review family wealth across governance, continuity, liquidity, reporting and product access with a structured RM-led conversation.",
    twitterTitle: "Family Office Services in India | Choice Wealth",
    twitterDescription: "Review family wealth across governance, continuity, liquidity, reporting and product access with a structured RM-led conversation.",
    canonical: "https://choicewealth.in/family-office-business-families",
  },
  whoWeServeBusinessOwnersPromoters: {
    metaTitle: "Wealth Management for Business Owners | Choice Wealth",
    metaDescription: "Review business-linked wealth across personal capital, surplus, concentration, liquidity, family context and product access.",
    ogTitle: "Wealth Management for Business Owners | Choice Wealth",
    ogDescription: "Review business-linked wealth across personal capital, surplus, concentration, liquidity, family context and product access.",
    twitterTitle: "Wealth Management for Business Owners | Choice Wealth",
    twitterDescription: "Review business-linked wealth across personal capital, surplus, concentration, liquidity, family context and product access.",
    canonical: "https://choicewealth.in/business-owners-promoters",
  },
  businessOwnersPromoters: {
    metaTitle: "Wealth Management for Business Owners | Choice Wealth",
    metaDescription: "Review business-linked wealth across personal capital, surplus, concentration, liquidity, family context and product access.",
    ogTitle: "Wealth Management for Business Owners | Choice Wealth",
    ogDescription: "Review business-linked wealth across personal capital, surplus, concentration, liquidity, family context and product access.",
    twitterTitle: "Wealth Management for Business Owners | Choice Wealth",
    twitterDescription: "Review business-linked wealth across personal capital, surplus, concentration, liquidity, family context and product access.",
    canonical: "https://choicewealth.in/business-owners-promoters",
  },
  whoWeServeFoundersEntrepreneurs: {
    metaTitle: "Founder Wealth Management | Choice Wealth",
    metaDescription: "Review founder wealth before or after liquidity across concentration, capital parking, global context and long-term allocation.",
    ogTitle: "Founder Wealth Management | Choice Wealth",
    ogDescription: "Review founder wealth before or after liquidity across concentration, capital parking, global context and long-term allocation.",
    twitterTitle: "Founder Wealth Management | Choice Wealth",
    twitterDescription: "Review founder wealth before or after liquidity across concentration, capital parking, global context and long-term allocation.",
    canonical: "https://choicewealth.in/founders-entrepreneurs",
  },
  foundersEntrepreneurs: {
    metaTitle: "Founder Wealth Management | Choice Wealth",
    metaDescription: "Review founder wealth before or after liquidity across concentration, capital parking, global context and long-term allocation.",
    ogTitle: "Founder Wealth Management | Choice Wealth",
    ogDescription: "Review founder wealth before or after liquidity across concentration, capital parking, global context and long-term allocation.",
    twitterTitle: "Founder Wealth Management | Choice Wealth",
    twitterDescription: "Review founder wealth before or after liquidity across concentration, capital parking, global context and long-term allocation.",
    canonical: "https://choicewealth.in/founders-entrepreneurs",
  },
  whoWeServeCxosSeniorProfessionals: {
    metaTitle: "Executive Wealth Management | Choice Wealth",
    metaDescription: "Review executive wealth across salary surplus, bonus, ESOPs, employer stock, retirement readiness and portfolio structure.",
    ogTitle: "Executive Wealth Management | Choice Wealth",
    ogDescription: "Review executive wealth across salary surplus, bonus, ESOPs, employer stock, retirement readiness and portfolio structure.",
    twitterTitle: "Executive Wealth Management | Choice Wealth",
    twitterDescription: "Review executive wealth across salary surplus, bonus, ESOPs, employer stock, retirement readiness and portfolio structure.",
    canonical: "https://choicewealth.in/cxos-senior-professionals",
  },
  cxosSeniorProfessionals: {
    metaTitle: "Executive Wealth Management | Choice Wealth",
    metaDescription: "Review executive wealth across salary surplus, bonus, ESOPs, employer stock, retirement readiness and portfolio structure.",
    ogTitle: "Executive Wealth Management | Choice Wealth",
    ogDescription: "Review executive wealth across salary surplus, bonus, ESOPs, employer stock, retirement readiness and portfolio structure.",
    twitterTitle: "Executive Wealth Management | Choice Wealth",
    twitterDescription: "Review executive wealth across salary surplus, bonus, ESOPs, employer stock, retirement readiness and portfolio structure.",
    canonical: "https://choicewealth.in/cxos-senior-professionals",
  },
  whoWeServePrivateClientWealth: {
    metaTitle: "Private Client Wealth Management | Choice Wealth",
    metaDescription: "Review serious portfolios through a private client desk focused on product access, reporting context and RM-led review rhythm.",
    ogTitle: "Private Client Wealth Management | Choice Wealth",
    ogDescription: "Review serious portfolios through a private client desk focused on product access, reporting context and RM-led review rhythm.",
    twitterTitle: "Private Client Wealth Management | Choice Wealth",
    twitterDescription: "Review serious portfolios through a private client desk focused on product access, reporting context and RM-led review rhythm.",
    canonical: "https://choicewealth.in/private-client-wealth",
  },
  privateClientWealth: {
    metaTitle: "Private Client Wealth Management | Choice Wealth",
    metaDescription: "Review serious portfolios through a private client desk focused on product access, reporting context and RM-led review rhythm.",
    ogTitle: "Private Client Wealth Management | Choice Wealth",
    ogDescription: "Review serious portfolios through a private client desk focused on product access, reporting context and RM-led review rhythm.",
    twitterTitle: "Private Client Wealth Management | Choice Wealth",
    twitterDescription: "Review serious portfolios through a private client desk focused on product access, reporting context and RM-led review rhythm.",
    canonical: "https://choicewealth.in/private-client-wealth",
  },
  portfolioHealthReview: {
    metaTitle: "Portfolio Health Review | Choice Wealth",
    metaDescription: "Review portfolio health across risk, liquidity, concentration, product exposure and review rhythm before adding more products.",
    ogTitle: "Portfolio Health Review | Choice Wealth",
    ogDescription: "Review portfolio health across risk, liquidity, concentration, product exposure and review rhythm before adding more products.",
    twitterTitle: "Portfolio Health Review | Choice Wealth",
    twitterDescription: "Review portfolio health across risk, liquidity, concentration, product exposure and review rhythm before adding more products.",
    canonical: "https://choicewealth.in/portfolio-health-review",
  },
  structuredWealthReview: {
    metaTitle: "Structured Wealth Review | Choice Wealth",
    metaDescription: "Review capital across goals, risk, liquidity, product roles and review discipline before product access is discussed.",
    ogTitle: "Structured Wealth Review | Choice Wealth",
    ogDescription: "Review capital across goals, risk, liquidity, product roles and review discipline before product access is discussed.",
    twitterTitle: "Structured Wealth Review | Choice Wealth",
    twitterDescription: "Review capital across goals, risk, liquidity, product roles and review discipline before product access is discussed.",
    canonical: "https://choicewealth.in/structured-wealth-review",
  },
  taxAwarePortfolioReview: {
    metaTitle: "Tax-Aware Portfolio Review | Choice Wealth",
    metaDescription: "Review tax-aware portfolio context across holdings, gains and product taxation. Tax matters should be reviewed with qualified professionals.",
    ogTitle: "Tax-Aware Portfolio Review | Choice Wealth",
    ogDescription: "Review tax-aware portfolio context across holdings, gains and product taxation. Tax matters should be reviewed with qualified professionals.",
    twitterTitle: "Tax-Aware Portfolio Review | Choice Wealth",
    twitterDescription: "Review tax-aware portfolio context across holdings, gains and product taxation. Tax matters should be reviewed with qualified professionals.",
    canonical: "https://choicewealth.in/tax-aware-portfolio-review",
  },
  retirementWealthReview: {
    metaTitle: "Retirement Wealth Review | Choice Wealth",
    metaDescription: "Review retirement readiness across corpus, income, liquidity, NPS, fixed income, mutual funds and review rhythm.",
    ogTitle: "Retirement Wealth Review | Choice Wealth",
    ogDescription: "Review retirement readiness across corpus, income, liquidity, NPS, fixed income, mutual funds and review rhythm.",
    twitterTitle: "Retirement Wealth Review | Choice Wealth",
    twitterDescription: "Review retirement readiness across corpus, income, liquidity, NPS, fixed income, mutual funds and review rhythm.",
    canonical: "https://choicewealth.in/retirement-wealth-review",
  },
  legacyWealthTransferCoordination: {
    metaTitle: "Legacy Wealth Transfer Coordination | Choice Wealth",
    metaDescription: "Review family wealth transfer context across ownership, nominations, beneficiaries and product holdings, with qualified professional coordination where needed.",
    ogTitle: "Legacy Wealth Transfer Coordination | Choice Wealth",
    ogDescription: "Review family wealth transfer context across ownership, nominations, beneficiaries and product holdings, with qualified professional coordination where needed.",
    twitterTitle: "Legacy Wealth Transfer Coordination | Choice Wealth",
    twitterDescription: "Review family wealth transfer context across ownership, nominations, beneficiaries and product holdings, with qualified professional coordination where needed.",
    canonical: "https://choicewealth.in/legacy-wealth-transfer-coordination",
  },
  globalInvestmentSolutions: {
    metaTitle: "Global Investment Solutions | Choice Wealth",
    metaDescription: "Review global investment context across residency, documentation, currency, jurisdiction, eligibility, risk and product access.",
    ogTitle: "Global Investment Solutions | Choice Wealth",
    ogDescription: "Review global investment context across residency, documentation, currency, jurisdiction, eligibility, risk and product access.",
    twitterTitle: "Global Investment Solutions | Choice Wealth",
    twitterDescription: "Review global investment context across residency, documentation, currency, jurisdiction, eligibility, risk and product access.",
    canonical: "https://choicewealth.in/global-investment-solutions",
  },
  whoWeServe: {
    metaTitle: "Who We Serve | Choice Wealth",
    metaDescription: "Start with your capital situation. Choice Wealth routes HNIs, NRIs, families, founders, CXOs and companies to the right wealth conversation.",
    ogTitle: "Who We Serve | Choice Wealth",
    ogDescription: "Start with your capital situation. Choice Wealth routes HNIs, NRIs, families, founders, CXOs and companies to the right wealth conversation.",
    twitterTitle: "Who We Serve | Choice Wealth",
    twitterDescription: "Start with your capital situation. Choice Wealth routes HNIs, NRIs, families, founders, CXOs and companies to the right wealth conversation.",
    canonical: "https://choicewealth.in/who-we-serve",
  },
  servicesHub: {
    metaTitle: "Wealth Management Services | Choice Wealth",
    metaDescription: "Explore review-led wealth services across portfolio health, tax-aware context, retirement, liquidity, global exposure and legacy coordination.",
    ogTitle: "Wealth Management Services | Choice Wealth",
    ogDescription: "Explore review-led wealth services across portfolio health, tax-aware context, retirement, liquidity, global exposure and legacy coordination.",
    twitterTitle: "Wealth Management Services | Choice Wealth",
    twitterDescription: "Explore review-led wealth services across portfolio health, tax-aware context, retirement, liquidity, global exposure and legacy coordination.",
    canonical: "https://choicewealth.in/services",
  },
  productsHub: {
    metaTitle: "Investment Products for HNIs | Choice Wealth",
    metaDescription: "Explore PMS, AIFs, mutual funds, fixed income, NPS and other product routes after portfolio context, eligibility and risk review.",
    ogTitle: "Investment Products for HNIs | Choice Wealth",
    ogDescription: "Explore PMS, AIFs, mutual funds, fixed income, NPS and other product routes after portfolio context, eligibility and risk review.",
    twitterTitle: "Investment Products for HNIs | Choice Wealth",
    twitterDescription: "Explore PMS, AIFs, mutual funds, fixed income, NPS and other product routes after portfolio context, eligibility and risk review.",
    canonical: "https://choicewealth.in/products",
  },
  aboutUs: {
    metaTitle: "Our Story | Choice Wealth",
    metaDescription: "See how Choice Wealth brings structure, discipline and RM-led wealth conversations to serious capital across India.",
    ogTitle: "Our Story | Choice Wealth",
    ogDescription: "See how Choice Wealth brings structure, discipline and RM-led wealth conversations to serious capital across India.",
    twitterTitle: "Our Story | Choice Wealth",
    twitterDescription: "See how Choice Wealth brings structure, discipline and RM-led wealth conversations to serious capital across India.",
    canonical: "https://choicewealth.in/our-story",
  },
  boardMembersPageTwo: {
    metaTitle: "Choice Group | Choice Wealth",
    metaDescription: "Learn about Choice Group's financial-services ecosystem and the institutional context behind Choice Wealth.",
    ogTitle: "Choice Group | Choice Wealth",
    ogDescription: "Learn about Choice Group's financial-services ecosystem and the institutional context behind Choice Wealth.",
    twitterTitle: "Choice Group | Choice Wealth",
    twitterDescription: "Learn about Choice Group's financial-services ecosystem and the institutional context behind Choice Wealth.",
    canonical: "https://choicewealth.in/group",
  },
  coreTeam: {
    metaTitle: "Core Team | Choice Wealth",
    metaDescription: "Meet the leadership and core team shaping Choice Wealth's structured, review-led approach for serious portfolios.",
    ogTitle: "Core Team | Choice Wealth",
    ogDescription: "Meet the leadership and core team shaping Choice Wealth's structured, review-led approach for serious portfolios.",
    twitterTitle: "Core Team | Choice Wealth",
    twitterDescription: "Meet the leadership and core team shaping Choice Wealth's structured, review-led approach for serious portfolios.",
    canonical: "https://choicewealth.in/core-team",
  },
  board: {
    metaTitle: "Board Members | Choice Wealth",
    metaDescription: "View the board members guiding Choice Wealth with governance, financial discipline and long-term institutional direction.",
    ogTitle: "Board Members | Choice Wealth",
    ogDescription: "View the board members guiding Choice Wealth with governance, financial discipline and long-term institutional direction.",
    twitterTitle: "Board Members | Choice Wealth",
    twitterDescription: "View the board members guiding Choice Wealth with governance, financial discipline and long-term institutional direction.",
    canonical: "https://choicewealth.in/board-members",
  },
  wealthManagers: {
    metaTitle: "Wealth Managers | Choice Wealth",
    metaDescription: "Meet the Choice Wealth managers supporting RM-led conversations, portfolio reviews and structured wealth solutions.",
    ogTitle: "Wealth Managers | Choice Wealth",
    ogDescription: "Meet the Choice Wealth managers supporting RM-led conversations, portfolio reviews and structured wealth solutions.",
    twitterTitle: "Wealth Managers | Choice Wealth",
    twitterDescription: "Meet the Choice Wealth managers supporting RM-led conversations, portfolio reviews and structured wealth solutions.",
    canonical: "https://choicewealth.in/wealth-managers",
  },
  contactUs: {
    metaTitle: "Contact Choice Wealth | Wealth Access Desk",
    metaDescription: "Share your wealth context and the relevant Choice Wealth desk will connect for an RM-led review conversation.",
    ogTitle: "Contact Choice Wealth | Wealth Access Desk",
    ogDescription: "Share your wealth context and the relevant Choice Wealth desk will connect for an RM-led review conversation.",
    twitterTitle: "Contact Choice Wealth | Wealth Access Desk",
    twitterDescription: "Share your wealth context and the relevant Choice Wealth desk will connect for an RM-led review conversation.",
    canonical: "https://choicewealth.in/contact-us",
  },
  ourPhilosophy: {
    metaTitle: "Choice Wealth Philosophy | Structure Before Products",
    metaDescription: "Understand Choice Wealth's review-first philosophy for serious capital, structured conversations and disciplined product access.",
    ogTitle: "Choice Wealth Philosophy | Structure Before Products",
    ogDescription: "Understand Choice Wealth's review-first philosophy for serious capital, structured conversations and disciplined product access.",
    twitterTitle: "Choice Wealth Philosophy | Structure Before Products",
    twitterDescription: "Understand Choice Wealth's review-first philosophy for serious capital, structured conversations and disciplined product access.",
    canonical: "https://choicewealth.in/our-philosophy",
  },
  blogIndex: {
    metaTitle: "Blog | Choice Wealth",
    metaDescription: "Perspectives from the Choice Wealth desk on portfolio review, manager research, product roles and long-term wealth structure.",
    ogTitle: "Blog | Choice Wealth",
    ogDescription: "Perspectives from the Choice Wealth desk on portfolio review, manager research, product roles and long-term wealth structure.",
    twitterTitle: "Blog | Choice Wealth",
    twitterDescription: "Perspectives from the Choice Wealth desk on portfolio review, manager research, product roles and long-term wealth structure.",
    canonical: "https://choicewealth.in/blog",
  },
  privacyPolicy: {
    metaTitle: "Privacy Policy | Choice Wealth",
    metaDescription: "Read Choice Wealth's privacy policy to understand how user information may be collected, used and protected.",
    ogTitle: "Privacy Policy | Choice Wealth",
    ogDescription: "Read Choice Wealth's privacy policy to understand how user information may be collected, used and protected.",
    twitterTitle: "Privacy Policy | Choice Wealth",
    twitterDescription: "Read Choice Wealth's privacy policy to understand how user information may be collected, used and protected.",
    canonical: "https://choicewealth.in/privacy-policy",
  },
  termsAndConditions: {
    metaTitle: "Terms and Conditions | Choice Wealth",
    metaDescription: "Read the terms and conditions governing use of the Choice Wealth website, content and digital services.",
    ogTitle: "Terms and Conditions | Choice Wealth",
    ogDescription: "Read the terms and conditions governing use of the Choice Wealth website, content and digital services.",
    twitterTitle: "Terms and Conditions | Choice Wealth",
    twitterDescription: "Read the terms and conditions governing use of the Choice Wealth website, content and digital services.",
    canonical: "https://choicewealth.in/terms-and-conditions",
  },
};
